// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-switch-checked {
    background-color: #0FB680 !important;
}

.assessment-creation-access {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 15px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 15px;
}
.assessment-creation-access p {
  color: #666;
  font-size: 13px;
  margin: 4px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Assessment/Partials/AssignSubscription/styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":[".ant-switch-checked {\n    background-color: #0FB680 !important;\n}\n\n.assessment-creation-access {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 15px;\n  border: 1px solid #e8e8e8;\n  border-radius: 8px;\n  background-color: #fff;\n  margin-bottom: 15px;\n}\n.assessment-creation-access p {\n  color: #666;\n  font-size: 13px;\n  margin: 4px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
